/**
 * International portal identity: electric cyan → indigo → purple → rose.
 * Use for gradients, stats (today / streak / best), and glows across the user dashboard.
 */
export const portal = {
  cyan: '#4FACFE',
  indigo: '#6366F1',
  purple: '#9333EA',
  rose: '#E11D48',
  pink: '#EC4899',
  amber: '#FBBF24',
  gold: '#F59E0B',
  /** Deepest app background (dark mode) */
  surfaceDeep: '#0B0B0F',
  /** Slightly lifted surfaces */
  surfaceCard: '#12121C',
  /** Hero / nav / primary CTAs */
  gradientHero:
    'linear-gradient(135deg, #4FACFE 0%, #6366F1 40%, #9333EA 72%, #E11D48 100%)',
  /** Shorter variant for buttons & table headers */
  gradientBold:
    'linear-gradient(135deg, #4FACFE 0%, #6366F1 55%, #9333EA 100%)',
  /** Thin accent bars (e.g. referral cards) */
  gradientBar:
    'linear-gradient(90deg, #4FACFE 0%, #6366F1 40%, #9333EA 70%, #EC4899 100%)',
  /** Slightly dimmed for `contained` button hover */
  gradientHeroHover:
    'linear-gradient(135deg, #3d9ef0 0%, #5558E8 42%, #8224D8 72%, #D0154A 100%)',
  /** Alternate direction for variety (e.g. admin hero accents) */
  gradientHeroReverse:
    'linear-gradient(135deg, #E11D48 0%, #9333EA 38%, #6366F1 72%, #4FACFE 100%)',
  statToday: '#4FACFE',
  statStreak: '#FBBF24',
  statBest: '#F43F5E',
  /**
   * Headlines & large metrics: warm gold/amber → ice cyan (matches Activity streak digit).
   * Use with `background-clip: text` (see `portalGradientTextSx`).
   */
  gradientTextWarm:
    'linear-gradient(125deg, #FDE047 0%, #FBBF24 12%, #F59E0B 38%, #38BDF8 72%, #7DD3FC 100%)',
};

/** Same gradient string as `portal.gradientHero` for quick find-replace imports */
export const PORTAL_GRADIENT = portal.gradientHero;

/**
 * MUI `sx` slice for multi-colour gradient text (e.g. page titles, stat digits).
 * @param {object} [extra] - merged last (e.g. fontWeight, fontSize)
 * @param {string} [gradient] — defaults to {@link portal.gradientTextWarm}
 */
export function portalGradientTextSx(extra = {}, gradient = portal.gradientTextWarm) {
  return {
    background: gradient,
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    ...extra,
  };
}
